import { memo } from 'react';
import { Icon, Grid, Button, TextField } from '@material-ui/core';
import { useStyles } from './styles';
import { useTranslation } from 'react-i18next';
import { ClearFilters } from '../../../elements';

interface TranslationSearchProps {
  searchValue: string;
  applySearch: () => void;
  resetSearch: () => void;
  setSearchValue: (value: string) => void;
}

const TranslationSearch = memo(({ applySearch, searchValue, setSearchValue, resetSearch }: TranslationSearchProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid item container direction="row" spacing={1} className={classes.searchRow}>
      <Grid item md={5} xs={6}>
        <TextField
          fullWidth
          size="small"
          variant="outlined"
          value={searchValue}
          label={t('f-com-text')}
          className={classes.withMargin}
          onChange={(e) => setSearchValue(e.target.value)}
        />
      </Grid>

      <Grid item>
        {/* apply search */}
        <Button
          size="medium"
          id="searchBtn"
          color="primary"
          variant="contained"
          onClick={applySearch}
          disabled={!searchValue}
          className={classes.withMargin}
          startIcon={<Icon>{'search'}</Icon>}
        >
          {t('f-search')}
        </Button>

        {/* reset search */}
        <ClearFilters onClick={resetSearch} />
      </Grid>
    </Grid>
  );
});

export default TranslationSearch;
